import axios from "axios";
import { NotImplementedError } from "../../errors";
import { PromiseHandler } from "../../handlers";
import { RemoteConfigProperties } from "../../models/featureFlags";
import { FeatureFlagsFetchFailed, FeatureFlagsPermissionDenied, FeatureFlagsSaveFailed } from "./errors";
export default class FeatureFlags extends PromiseHandler {
    constructor(sdk) {
        super(sdk, "featureFlags");
        this.state = {};
        this.loading = new Promise((resolve) => {
            this.resolveLoading = resolve;
        });
    }
    get url() {
        return `${this.sdk.urls.identityBaseUrl}/feature-flags`;
    }
    isFlagEnabled(key) {
        return this.state[key] === true;
    }
    async load() {
        try {
            await this.find();
        }
        finally {
            this.resolveLoading();
        }
    }
    async loaded() {
        return this.loading;
    }
    async findItems() {
        const [state] = await this.cache
            .promise(this.url, () => axios.get(this.url).then(({ data }) => [data]))
            .catch((error) => {
            throw new FeatureFlagsFetchFailed(error);
        });
        this.state = state;
        this.resolveLoading();
        return [state];
    }
    /**
     * Sets flags for the caller's organization, all or nothing. Resolves with the
     * caller's re-evaluated flags, not just the ones changed.
     */
    async saveItem(changes) {
        try {
            const { data } = await axios.put(this.url, { flags: changes });
            this.state = data;
            return data;
        }
        catch (error) {
            if (axios.isAxiosError(error) && error.response?.status === 403) {
                throw new FeatureFlagsPermissionDenied(error);
            }
            throw new FeatureFlagsSaveFailed(error);
        }
    }
    async deleteItem() {
        throw new NotImplementedError("delete");
    }
    get useSDKFeatureFlags() {
        return true;
    }
    isSupplySelectorEnabled(area) {
        const isMasterSupplySelectorEnabled = this.isFlagEnabled(RemoteConfigProperties.SUPPLY_SELECTOR);
        const flagMap = {
            product: RemoteConfigProperties.SUPPLY_SELECTOR_PRODUCT,
            "line item": RemoteConfigProperties.SUPPLY_SELECTOR_LINE_ITEM,
            planner: RemoteConfigProperties.SUPPLY_SELECTOR_PLANNER,
            reporting: RemoteConfigProperties.SUPPLY_SELECTOR_REPORTING
        };
        const isSpecificFlagEnabled = this.isFlagEnabled(flagMap[area]);
        return isMasterSupplySelectorEnabled || isSpecificFlagEnabled;
    }
}
//# sourceMappingURL=index.js.map